export const CONFLICT_ERROR = 409;
export const NO_AUTH_STATUS = 401;
export const MIN_CODE_ERROR = 400;
export const BAD_REQUEST = 400;
export const OK_RESPONSE = 200;
export const NO_CONTENT_RESPONSE = 204;
